import { authClient, API } from '../../utils/index'

// Todo /contract es de administración: lo cierra el backend, no el panel.

export const getContracts = () => authClient().get(`${API}/contract`)

export const getContractById = (id) => authClient().get(`${API}/contract/${id}`)

export const getContractsByClub = (club) => authClient().get(`${API}/contract/club/${club}`)

export const postContract = (contract) => authClient().post(`${API}/contract`, contract)

export const updateContract = (id, contract) => authClient().put(`${API}/contract/${id}`, contract)

export const deleteContract = (id) => authClient().delete(`${API}/contract/${id}`)

/**
 * Anota el aviso de baja. La fecha efectiva la calcula el servidor con las
 * tres reglas (mínimo, aviso y renovación) y la devuelve ya guardada.
 */
export const noticeContract = (id, noticeGivenAt) =>
	authClient().post(`${API}/contract/${id}/baja`, { noticeGivenAt })

/** El catálogo vive en el servidor. Aquí NO se repiten precios. */
export const getCatalogo = () => authClient().get(`${API}/contract/catalogo`)

export const simular = (aparatos, compromiso = false) =>
	authClient().get(`${API}/contract/simular?aparatos=${aparatos}&compromiso=${compromiso}`)

/** Qué pasaría al dar de alta. No escribe nada. */
export const ensayarAlta = (pedido) => authClient().post(`${API}/contract/ensayar`, pedido)

/** El alta de verdad: club, gestor, contrato y aparatos. */
export const provisionarClub = (pedido) => authClient().post(`${API}/contract/provisionar`, pedido)

/**
 * Las tarifas de envío y asistencia.
 *
 * Son las dos que se revisan varias veces al año —dependen del transportista y
 * de la gasolina—, así que viven en la base y se cambian desde aquí. Los packs
 * y el alta NO: eso es el modelo, está en el código y se piensa despacio.
 */
export const getTarifas = () => authClient().get(`${API}/contract/tarifas`)

export const updateTarifas = (tarifas) => authClient().put(`${API}/contract/tarifas`, tarifas)
